export interface IWsSolicitud {
    IdSolicitud: number;
    IdContacto: number;
    nombre: string;
    apellidos: string;
    apePaterno: string;
    apeMaterno: string;
    email: string;
    celular: string;
    IdCliente: number;
    RazonSocial: string;
    TipoSolicitud: string;
    Asunto: string;
    Detalle: string;
    flagCodificacion: boolean;
    flagSuply: boolean;
    flagInspeccion: boolean;
    flagOmr: boolean;
    flagInsumos: boolean;
    flagSoftware: boolean;
    flagAtendido: boolean;
    fechaRegistro: string;
    fechaAtencion: string;
}

export class WsSolicitud {
    IdSolicitud: number;
    IdContacto: number;
    nombre: string;
    apellidos: string;
    apePaterno: string;
    apeMaterno: string;
    email: string;
    celular: string;
    IdCliente: number;
    RazonSocial: string;
    TipoSolicitud: string;
    Asunto: string;
    Detalle: string;
    flagCodificacion: boolean;
    flagSuply: boolean;
    flagInspeccion: boolean;
    flagOmr: boolean;
    flagInsumos: boolean;
    flagSoftware: boolean;
    flagAtendido: boolean;
    fechaRegistro: string;
    fechaAtencion: string;

    constructor(data?: IWsSolicitud) {
        if (data) {
            this.IdSolicitud = data.IdSolicitud;
            this.IdContacto = data.IdContacto;
            this.nombre = data.nombre;
            this.apellidos = data.apellidos;
            this.apePaterno = data.apePaterno;
            this.apeMaterno = data.apeMaterno;
            this.email = data.email;
            this.celular = data.celular;
            this.IdCliente = data.IdCliente;
            this.RazonSocial = data.RazonSocial;
            this.TipoSolicitud = data.TipoSolicitud;
            this.Asunto = data.Asunto;
            this.Detalle = data.Detalle;
            this.flagCodificacion = data.flagCodificacion;
            this.flagSuply = data.flagSuply;
            this.flagInspeccion = data.flagInspeccion;
            this.flagOmr = data.flagOmr;
            this.flagInsumos = data.flagInsumos;
            this.flagSoftware = data.flagSoftware;
            this.flagAtendido = data.flagAtendido;
            this.fechaRegistro = data.fechaRegistro;
            this.fechaAtencion = data.fechaAtencion;
        }
    }
}
